const themeMap = {
  css: {
    '--theme-header-bg': '#00414D', // 顶部栏背景色
    '--theme-body-bg': '#10131a', // 页面背景色
    '--theme-header-img': '', // 顶部栏背景图
    '--theme-header-title-text-shadow': 'none', // 顶部栏title text shadow
    '--theme-header-title-font-size': '24px', // 顶部栏title 字体大小
    '--theme-header-title-font-weight': '600', // 顶部栏title 字体权重
    '--theme-ant-select-selector-border-color': 'rgba(255, 255, 255, 0.12)', // 顶部栏选择框边框颜色
    '--theme-header-downoutlined-color': 'rgba(255, 255, 255, 0.28)', // 顶部栏下拉菜单箭头颜色
    '--theme-content-box-left-icon-url': '', // content box 顶部左边图标
    '--theme-content-box-top-bg': 'none', // content box 顶部渐变色
    // 通用
    '--theme-legend-mask-bg': '#5B818C', // tree/select/input组件下拉框背景色、图层、图例等mask背景色
    '--theme-legend-bg': 'rgba(0, 42, 51, 0.88)', // 图层、图例等背景色
    '--theme-tooltip-indicator-color': 'rgba(255, 255, 255, 0.7)', // 图层、图例等文字
    '--theme-tooltip-indicator-sub-color': 'rgba(255, 255, 255, 0.5)', // 统计模块subtext等文字
    '--theme-tooltip-indicator-label-color': 'rgba(255, 255, 255, 0.7)', // 图层、图例等文字
    '--theme-tooltip-divider-bg': 'rgba(255, 255, 255, 0.08)', // 图层、图例等分割线
    '--theme-legend-title-color': 'rgba(255, 255, 255, 0.7)', // 图例列标题颜色
    '--theme-indicator-num-bg': 'rgba(0, 42, 51, 0.5)', // 统计指标-数字框背景色
    '--theme-indicator-num-color': '#45E5BD', // 统计指标-数字颜色
    '--theme-indicator-num-box-shadow':
      '0px 2px 6px 0px rgba(23, 51, 51, 0.3),inset 0px 0px 2px 0px rgba(255, 255, 255, 0.2)', // 统计指标-数字框box shadow
    '--theme-indicator-num-border-bg': 'none', // 统计指标-数字框border
    '--theme-content-box-sel-biz-color': '#45E5BD', // 统计指标-业务线选中颜色
    '--theme-content-box-biz-color': 'rgba(255, 255, 255, 0.7)', // 统计指标-业务线默认颜色
    '--theme-header-title-color': '#45E5BD', // 单个数据中心高亮色
    '--theme-legend-select-item-default-color': '#5B818C', // 图层选择项默认颜色
    '--theme-legend-select-item-selected-color': 'rgba(69, 229, 189, 0.2)', // 图层选择项选中颜色
    '--theme-legend-select-item-selected-border-color': '#45E5BD', // 图层选择项选中边框颜色
    '--theme-legend-select-item-text-color': 'rgba(255, 255, 255, 0.7)', // 图层选择项文字颜色
    '--theme-layer-control-title-color': 'rgba(255, 255, 255, 0.7)', // 图层控制标题颜色（车辆类型、车辆状态、车辆品牌等）
    '--theme-map-dialog-bg': '#425666', // 地图 - 弹窗背景色
    '--theme-common-dialog-bg': '#425e66', // 弹窗背景色
    '--theme-common-dialog-module-bg': '#32484c', // 弹窗-模块背景色
    '--theme-common-dialog-table-th-bg': '#516367', // 弹窗-表格表头背景色
    '--theme-common-dialog-table-td-bg': '#3e5357', // 弹窗-表格单元格背景色
    '--theme-collapse-btn-color': 'rgba(255, 255, 255, 0.7)', // 折叠按钮color
    '--theme-orderly-alarm-bg-color': '#E0812D', // 异常提醒背景色
    // 统计模块
    '--theme-content-box-bg': 'linear-gradient(0deg, #006073 0%, rgba(0, 42, 51, 0.95) 100%)', // 背景色
    '--theme-content-box-border-bg':
      'linear-gradient(180deg, #008099 0%, rgba(0, 128, 153, 0) 100%) border-box', // 边框色
    '--theme-content-box-title-bg': '#45E5BD', // 标题竖线颜色
    '--theme-content-box-bg-url': `url(${require('_root/assets/img/content_box_bg_green.png')})`, // 标题竖线背景图

    // 地图
    '--theme-map-search-input-group-bg': 'rgba(1, 53, 64, 1)', // 地图-输入框背景色
    '--theme-map-search-select-bg': 'rgba(91, 129, 140, 1)', // 地图-下拉选择背景色
    '--theme-map-search-clear-icon-color': '#FFFFFF', // 地图-搜索框清除图标颜色
    '--theme-map-search-input-text-color': '#FFFFFF', // 地图-搜索输入框文字颜色
    '--theme-map-modal-confrim-btn-bg': '#45E5BD', // 地图-弹窗确认按钮背景色
    '--theme-map-table-th-bg': 'rgba(0, 0, 0, 0.15)', // 地图-table 表头按钮背景色
    '--theme-map-heat-slider-bg': 'linear-gradient(180deg, rgba(0, 42, 51, 0.95) 0%, #006073 100%)', // 地图-热力图slider 背景色
    '--theme-map-heat-slider-border-color':
      'linear-gradient(0deg, rgba(50, 166, 154, 0) 0%, #32A69A 100%)', // 地图-热力图slider border color
    '--theme-map-heat-slider-default-line-color': 'rgba(255, 255, 255, 0.2)', // 地图-热力图slider 线条默认颜色
    '--theme-map-heat-slider-highlight-line-color': '#45E5BD', // 地图-热力图slider 线条高亮颜色
    '--theme-map-heat-slider-hover-line-color': '#45E5BD', // 地图-热力图slider 线条hover颜色
    '--theme-map-heat-slider-active-dot-color': '#FFFFFF', // 地图-热力图slider 选中点颜色
    '--theme-map-heat-slider-mark-color': 'rgba(255, 255, 255, 0.9)', // 地图-热力图slider 字体颜色
    '--theme-map-city-info-border-color': 'rgba(0, 153, 115, 0.3)', // 地图-城市信息气泡border颜色
    '--theme-map-city-info-bg': 'rgba(69, 229, 189, 0.8)', // 地图-城市信息气泡颜色
    '--theme-map-city-info-color': '#151e2d', // 地图-城市信息气泡主color
    '--theme-map-city-operation-info-color': 'rgba(21, 30, 45, 0.7)', // 地图-城市信息气泡 操作人员等信息color
    '--theme-layer-control-item-outer-bg': 'transparent', // 边框色
    '--theme-layer-control-text-color': '#FFFFFF', // 图层控制项文字颜色
    '--theme-layer-control-item-bg': 'rgba(0, 42, 51, 0.88)', // 图层控制项背景色
    '--theme-map-city-info-outer-box-bg-img': '', // area_donut_outer
    '--theme-map-city-info-outer-box-bg': 'transparent', // 地图-城市信息气泡背景
    '--theme-map-city-info-outer-box-shadow': 'transparent', // 地图-城市信息气泡背景阴影-默认色
    '--theme-map-city-info-box-color': '#151e2d',
    '--theme-map-city-info-name-font-weight': '500',
    '--theme-map-city-info-name-font-size': '14px',
    '--theme-map-city-info-name-font-family': 'PingFangSC-Medium',
    '--theme-map-city-info-operation-font-weight': '400',
    '--theme-map-city-info-operation-font-size': '12px',
    '--theme-map-city-info-operation-font-family': 'AvenirBold',
    '--theme-map-city-info-count-font-weight': '900',
    '--theme-map-city-info-count-font-size': '24px',
    '--theme-map-city-info-count-font-family': 'Avenir',

    // 右侧功能按钮
    '--theme-right-button-bg-color': '#5B818C',
    '--theme-right-button-item-bg-color': '#5B818C',

    // 地图信息面板
    '--theme-map-info-card-bg': '#5B818C', // 地图信息面板背景色（聚合气泡点击面板）
    '--theme-map-info-card-text-color': 'rgba(255, 255, 255, 0.9)', // 地图信息面板字体颜色

    /* 车辆轨迹 */
    // 车辆轨迹订单悬浮颜色
    '--theme-bike-trail-order-hover-bg': 'rgba(69,229,189,0.1)',
    //车辆轨迹订单选中颜色
    '--theme-bike-trail-order-selected-bg': 'rgba(69,229,189,0.1)',
    // 车辆轨迹订单状态文字颜色
    '--theme-bike-trail-order-status-text-color': '#45E5BD',
  },
  '--theme-china-map-area-color-primary-0': '#3A977E', // 中国地图-有实体区域背景色0%
  '--theme-china-map-area-color-primary-100': '#3A977E', // 中国地图-有实体区域背景色100%
  '--theme-china-map-area-color-ghost-0': '#437373', // 中国地图-无实体区域背景色0%
  '--theme-china-map-area-color-ghost-100': '#437373', // 中国地图-无实体区域背景色100%

  '--theme-china-map-area-color-primary-hover-0': '#14CD9F', // 中国地图-有实体区域背景色 hover 0%
  '--theme-china-map-area-color-primary-hover-100': '#14CD9F', // 中国地图-有实体区域背景色 hover 100%
  '--theme-china-map-area-color-ghost-hover-0': '#518C8C', // 中国地图-无实体区域背景色 hover 0%
  '--theme-china-map-area-color-ghost-hover-100': '#518C8C', // 中国地图-无实体区域背景色 hover 100%

  '--theme-china-map-area-border-color-primary': '#46CCB6', // 中国地图-有实体区域边框色
  '--theme-china-map-area-border-color-ghost': '#7DBFB4', // 中国地图-无实体区域边框色

  '--theme-echarts-subtext-color': 'rgba(255, 255, 255, 0.9)', // echart折线图 subTitle color
  '--theme-echarts-y-axis-split-line-color': '#FFFFFF', // echart折线图 y轴分割线color
  '--theme-echarts-x-axis-split-line-color': 'rgba(255, 255, 255, 0.4)', // echart折线图 x轴分割线color
  '--theme-echarts-y-axis-axis-line-color': 'rgba(255, 255, 255, 0.4)', // echart折线图 y轴轴线color
  '--theme-echarts-x-axis-axis-line-color': 'rgba(255, 255, 255, 0.4)', // echart折线图 x轴轴线color
  '--theme-echarts-x-axis-axis-label-color': '#FFFFFF', // echart折线图 x轴label color
  '--theme-parking-normal-color': '#45E5BD', // 正常停车点统计指标color
  '--theme-content-box-pie-border-color': '#00404C', // echart饼图 border color
  '--theme-echarts-bar-color-1': '#E0812D', // 运维力量统计 柱状图柱子颜色
  '--theme-echarts-bar-color-2': '#45E5BD', // 车辆备案情况、实时上报车辆情况 柱状图柱子颜色
  '--theme-echarts-bar-color-3': 'rgba(255, 255, 255, 0)', // 车辆备案情况、实时上报车辆情况 柱状图柱子颜色 - 0%
  '--theme-echarts-bar-color-4': 'rgba(255, 255, 255, 0.15)', // 车辆备案情况、实时上报车辆情况 柱状图柱子颜色 - 100%
  '--theme-tooltip-hover-color': 'rgba(255, 255, 255, 0.12)', // echart图 toolTip hover颜色
  '--theme-tooltip-hover-color-1': 'rgba(255, 255, 255, 0)', // 地图-热力图slider 线条hover颜色 - 0%
  '--theme-tooltip-hover-color-2': 'rgba(255, 255, 255, 0.12)', // 地图-热力图slider 线条hover颜色 - 100%
  '--theme-echarts-bar-color-5': '#45d8e5', // 车辆累计未备案情况、实时上报车辆情况 柱状图柱子颜色

  '--theme-map-area-polygon-bg': 'rgba(23, 229, 178, 0.1)', // 地图区域-polygon背景色
  '--theme-map-area-polygon-border-color': 'rgba(0, 204, 153, 1)', // 地图区域-polygon border color
  '--theme-map-cluster-bubble-close': 'rgba(255, 255, 255, 0.9)', // 地图info close color
  '--theme-map-area-donut-operator': `${require('_root/assets/img/areaDonutIcon/donut_operator_1.png')}`, // 地图气泡操作人icon
  '--theme-map-area-donut-car': `${require('_root/assets/img/areaDonutIcon/donut_operation_car_1.png')}`, // 地图气泡操作人icon

  '--theme-trend-down-img': `${require('_root/assets/img/trend_down_green.png')}`, // 工单实况下降箭头

  '--theme-order-patrol-detail-statistics-effective-count': '#C2F2EA', // 秩序巡视详情统计 有效巡视次数颜色
  '--theme-order-patrol-detail-statistics-nest-ratio': '#0ACC9C', // 秩序巡视详情统计 秩序整齐率颜色

  '--theme-operation-work-order-statistics-dispatch': '#45E5BD', // 运维工单统计 调度颜色
  '--theme-operation-work-order-statistics-charging': '#00CEED', // 运维工单统计 换电颜色
  '--theme-operation-work-order-statistics-maintain': '#00AAFF', // 运维工单统计 维修颜色
}

export default themeMap
